import { Truck, MapPin, Users, ShieldCheck, BadgeCheck, Coins, Recycle } from "lucide-react";

const FEATURES = [
    {
        icon: Truck,
        title: "Same Day or Next Day Delivery",
        body: "Fast turnaround across Sydney — call before lunch and we’ll do our best to be there today.",
    },
    {
        icon: MapPin,
        title: "Flexible Placement",
        body: "We position your bin where it suits your site — driveway, front yard or kerbside.",
    },
    {
        icon: Users,
        title: "Family Owned & Local",
        body: "A Sydney business that treats you like a neighbour, not a number.",
    },
    {
        icon: ShieldCheck,
        title: "Fully Insured",
        body: "Complete peace of mind on every residential and commercial job.",
    },
    {
        icon: BadgeCheck,
        title: "Transparent Pricing",
        body: "Clear quotes over the phone — no hidden fees, no surprises on the invoice.",
    },
    {
        icon: Coins,
        title: "Best Rates",
        body: "Competitive pricing on every bin size, from 2m³ mini skips to 8m³ builder bins.",
    },
];

export const WhyUs = () => {
    return (
        <section id="why-us" data-testid="section-why-us" className="py-14 md:py-20">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-2xl tp-reveal">
                    <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-tp-forest font-semibold">
                        <span className="h-1.5 w-1.5 rounded-full bg-tp-gold" />
                        Why choose us
                    </div>
                    <h2 className="mt-3 font-heading text-3xl md:text-4xl text-tp-forest leading-tight">
                        Local skip bin hire Sydney can rely on
                    </h2>
                    <p className="mt-3 text-sm md:text-base text-tp-ink/80">
                        Six honest reasons to book with Tipping Point Skips — the same reasons
                        our neighbours across Sydney book us again for their next clean-up.
                    </p>
                </div>

                <div className="mt-8 md:mt-10 grid gap-4 md:gap-6 sm:grid-cols-2 md:grid-cols-3">
                    {FEATURES.map((f) => (
                        <article
                            key={f.title}
                            data-testid={`why-us-feature-${f.title
                                .toLowerCase()
                                .replace(/[^a-z]+/g, "-")
                                .replace(/^-|-$/g, "")}`}
                            className="tp-reveal bg-white rounded-2xl p-5 md:p-6 border border-tp-forest/10 shadow-[0_10px_30px_rgba(20,83,45,0.06)] hover:shadow-[0_14px_40px_rgba(20,83,45,0.14)] transition-shadow"
                        >
                            <span className="inline-flex items-center justify-center h-11 w-11 rounded-lg bg-tp-forest/5 ring-1 ring-tp-gold/50">
                                <f.icon size={22} strokeWidth={2.2} className="text-tp-forest" />
                            </span>
                            <h3 className="mt-4 font-heading text-lg text-tp-forest leading-tight">
                                {f.title}
                            </h3>
                            <p className="mt-2 text-sm text-tp-ink/80">{f.body}</p>
                        </article>
                    ))}
                </div>

                <div className="mt-8 flex items-start gap-3 rounded-2xl bg-tp-recycle/10 border border-tp-recycle/30 p-4 md:p-5">
                    <span className="inline-flex items-center justify-center h-9 w-9 rounded-lg bg-white ring-1 ring-tp-recycle/40 shrink-0">
                        <Recycle size={18} strokeWidth={2.2} className="text-tp-recycle" />
                    </span>
                    <p className="text-sm text-tp-ink/85">
                        We’re proud to do the right thing with waste — sorting, recycling
                        and disposing of loads responsibly, wherever possible, at licensed
                        Sydney facilities.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default WhyUs;
